import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gratiora_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (
      err.response?.status === 401 &&
      window.location.pathname.startsWith("/admin") &&
      window.location.pathname !== "/admin/login"
    ) {
      localStorage.removeItem("gratiora_admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const imgUrl = (img) => {
  if (!img) return "";
  return img.startsWith("http") ? img : `${API}/files/${img}`;
};

let configCache = null;
export const getSiteConfig = async () => {
  if (configCache) return configCache;
  try {
    const { data } = await api.get("/config");
    configCache = data;
  } catch {
    configCache = {
      whatsapp_number: "919876543210",
      contact_email: "hello@gratiora.in",
      contact_phone: "+91 98765 43210",
      studio: "Studio 14, Shahpur Jat, New Delhi — Delhi NCR",
    };
  }
  return configCache;
};

export const waLink = (number, text) =>
  `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
